import {
  AUTHOR,
  BLOG_TILE_FIELDS,
  CLOUDINARY_ASSET_FIELDS,
  IMAGE_FIELDS,
  PORTABLE_TEXT_FIELDS,
} from './snippets';

const fields = `//groq
  _id,
  title,
  scheduledDatetime,
  "lastUpdated": dateModified,
  "displayDate": coalesce(displayDate, false),
  "slug": slug.current,
  relatedBlogs,
  "featuredProducts": featuredProducts[]->.productId,
  freeSampleBlurb,
  newsletterSubscribeBlurb,
  emailArticleBlurb,
  // "numberOfCharacters": length(pt::text(body)),
  // assumes 5 characters as mean word length
  // https://ux.stackexchange.com/questions/22520/how-long-does-it-take-to-read-x-number-of-characters
  // "estimatedWordCount": round(length(pt::text(body)) / 5),
  // Words per minute: 180
  "estimatedReadingTime": round(round(length(pt::text(body)) / 5) / 180),
  "difficultyLevel": body[_type == "recipe"][0].difficultyLevel,
  "featuredImage": select(
    featuredImage.asset._type == "cloudinary.asset" => featuredImage{
      ${CLOUDINARY_ASSET_FIELDS}
    },
    featuredImage._type == "image" => featuredImage{
      ${IMAGE_FIELDS}
    }, 
  ),
  "references": references[]{
      ...,
      markDefs[]{
          ...,
          _type == "internalLink" => {
            "slug": @.item->slug,
          }
      }
  },
  ${AUTHOR},
  "body": body[]{
    ${PORTABLE_TEXT_FIELDS}
  },
  "category": coalesce(category, ""),
  "summary": summary[] {
      ...,
      _type == "cloudinaryAsset" => @{
        ${CLOUDINARY_ASSET_FIELDS}
      },
      markDefs[]{
          ...,
          _type == "internalLink" => {
            "slug": @.item->slug,
          }
      }
  },
  "prebuild": coalesce(prebuild, false),
`;

export const getAllPrebuildBlogs = `//groq
    *[_type == "blogPost" 
    && !(_id in path("drafts.**")) 
    && defined(slug) 
    && defined(body) 
    && prebuild == true
    && dateTime(scheduledDatetime) <= dateTime(now())  
    ] 
    {
        ${fields}
    } | order(_createdAt desc)
`;

export const getBlogByPath = `//groq
    *[_type == "blogPost" 
    && !(_id in path("drafts.**")) 
    && defined(slug) 
    && defined(body) 
    && slug.current match $slug
    && dateTime(scheduledDatetime) <= dateTime(now())
    ]
    {
        ${fields}
    } | order(_updatedAt desc)
`;

export const getBlogById = `//groq
  *[_type == "blogPost" && _id == $id && defined(slug) && defined(body)]
    {
      ${fields}
    } | order(_updatedAt desc)
`;

export const getBlogCategories = `//groq
*[_type == "blogPost" 
  && !(_id in path("drafts.**")) 
  && defined(slug) 
  && defined(body)
  && dateTime(scheduledDatetime) <= dateTime(now())
] 
  {
    "category": coalesce(category, ""),
  }
`;

export const getBlogMetaDataQuery = `//groq
  *[_type == "blogPost" && _id == $id || _type == "siteSettings" && !(_id in path("drafts.**"))]
  {
    _type,
    metaTitle,
    metaDescription,
    noIndex,
    canonical
  }
`;

export const getBlogTiles = `//groq
  *[_type == "blogPost" 
    && !(_id in path("drafts.**")) 
    && defined(slug) 
    && defined(body)
    && dateTime(scheduledDatetime) <= dateTime(now())
    && ($category == "" || category == $category)
    && ($author == "" || author._ref == $author)
  ] 
  {
    ${BLOG_TILE_FIELDS}
  } | order(dateTime(scheduledDatetime) desc) [$start...$end]
`;

export const getBlogTilesByIds = `//groq
  *[_type == "blogPost" && _id in $ids && defined(slug) && defined(body)]
  {
    ${BLOG_TILE_FIELDS}
  } | order(_updatedAt desc)
`;
